var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inline-svg',{attrs:{"src":require(`../../node_modules/@skbkontur/icons/src/${_vm.iconFolderName}/Size=${this.size}, Style=${this.type}.svg`),"width":_vm.size,"height":_vm.size,"fill":"currentColor","role":"presentation","transformSource":_vm.transformSvg}})
}
var staticRenderFns = []

export { render, staticRenderFns }